<div (click)="toggleDropdown()" class="user-dropdown__backdrop"></div>
<div class="user-dropdown__wrapper">
  <profile-card (toggleDropdownHandler)="toggleDropdown()"></profile-card>
</div>